<template>
  <div class="cm-blackbar">
    <div class="cm-blackbar__header"></div>
    <div class="cm-blackbar__sideBar"></div>
    <div class="cm-blackbar__body">
      <slot></slot>
    </div>
    <div class="cm-blackbar__footer"></div>
  </div>
</template>

<script>

export default {
  props: {
    clientId: {
      type: String,
      require: true,
      default: '',
    },
    locationHref: {
      type: String,
      require: true,
      default: '',
    },
    memberOptions: {
      type: Array,
      default: () => null,
    },
    userInfo: {
      type: Object,
      default: () => {},
    },
    fixed: {
      type: Boolean,
      default: false,
    },
    isShowSidebar: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: Number,
      require: false,
      default: null,
    },
  },
  data() {
    return {
      blackBarInstance: null,
    };
  },
  watch: {
    locationHref: {
      handler(val) {
        if (val && this.blackBarInstance) {
          this.blackBarInstance.setInnerLinkActiveByHref(val);
        }
      },
      immediate: true,
    },
    userInfo: {
      handler(val) {
        if (val && this.blackBarInstance) {
          this.blackBarInstance.setUserInfo(val);
        }
      },
      immediate: true,
    },
    isShowSidebar: {
      handler(val) {
        if (val) {
          this.showSidebar();
        } else {
          this.closeSidebar();
        }
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      const self = this;

      // eslint-disable-next-line new-cap, no-undef
      this.blackBarInstance = new blackbar({
        clientId: self.clientId,
        fixed: self.fixed,
        innerlinkOptionList: [
          {
            id: 'forum-1',
            event: () => {
              console.log('click forum-1');
            },
          },
        ],
        memberInfo: {
          basicEvent: {
            login: {
              event: () => {
                console.log('login');
                this.$emit('login');
              },
            },
            logout: {
              event: () => {
                console.log('logout');
                this.$emit('logout');
              },
            },
            changeAccount: {
              event: () => {
                console.log('changeAccount');
                this.$emit('changeAccount');
              },
            },
            basicInfo: {
              event: () => {
                window.location.href = 'https://www.cmoney.tw/identity/account/info';
              },
            },
          },
          customList: self.memberOptions,
        },
      });

      await this.blackBarInstance.init();

      // zIndex 可能為 0，所以判斷是 number 才設定
      if (typeof this.zIndex === 'number') this.blackBarInstance.setZIndex(this.zIndex);

      this.innerLinkData = this.blackBarInstance.getInnerLinkData();

      // 當有內部資訊則根據目前網址變更選取的樣式
      if (this.innerLinkData && self.locationHref) {
        this.blackBarInstance.setInnerLinkActiveByHref(self.locationHref);
      }

      if (this.userInfo) {
        this.blackBarInstance.setUserInfo(self.userInfo);
      }

      // 將內部連結做更動,只取 pathname 做為相對路徑使用
      const innerLinkList = this.blackBarInstance.getInnerLinkData();
      if (innerLinkList) {
        const innerLinkOptionList = innerLinkList.map((item) => ({
          innerLinkId: item.innerLinkId,
          event() {
            // $router.push 需要把子目陸從 path 移除
            const path = new URL(item.href).pathname.replace(`/${self.clientId}/`, '/');
            const query = new URL(item.href).search;
            self.$router.push(path + query);
            self.blackBarInstance.closeSidebar();
          },
        }));

        this.blackBarInstance.setInnerLinkOptionList(innerLinkOptionList);
      }

      this.blackBarInstance.addEventListener('toggleSidebar', this.handleToggleSidebar);
    },
    handleToggleSidebar(isShow) {
      this.$emit('update:isShowSidebar', isShow);
    },
    showSidebar() {
      this.blackBarInstance.showSidebar();
    },
    closeSidebar() {
      this.blackBarInstance.closeSidebar();
    },
  },
  beforeDestroy() {
    this.blackBarInstance.removeEventListener('toggleSidebar', this.handleToggleSidebar);
  },
};
</script>

<style>

</style>
